import { TAG_VARIANTS } from '@private/components';

import { baseThemeValues } from 'constants/common';

const tagBase = {
  borderColor: 'palette.transparent',
  borderRadius: '16px',
  borderWidth: '0px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 400,
};

export const tagTheme = {
  baseProps: tagBase,
  button: {
    active: {
      bg: 'palette.black:0.2',
    },
    base: {
      bg: 'palette.transparent',
    },
    hover: {
      bg: 'palette.black:0.1',
    },
  },
  [TAG_VARIANTS.BLUE]: {
    ...tagBase,
    bg: 'palette.secondary.50',
    text: 'palette.secondary.5',
  },
  [TAG_VARIANTS.ERROR]: {
    ...tagBase,
    bg: 'palette.error.90:0.95',
    text: 'palette.error.20:0.9',
  },
  [TAG_VARIANTS.GRAY]: {
    ...tagBase,
    bg: 'palette.neutral.20:0.95',
    text: 'palette.neutral.90:0.9',
  },
  [TAG_VARIANTS.PRIMARY]: {
    ...tagBase,
    bg: 'palette.primary.20',
    text: 'palette.primary.99',
  },
  [TAG_VARIANTS.SUCCESS]: {
    ...tagBase,
    bg: 'palette.success.20:0.8',
    text: 'palette.success.90:0.8',
  },
  [TAG_VARIANTS.WARNING]: {
    ...tagBase,
    bg: 'palette.warning.20:0.8',
    text: 'palette.warning.90:0.8',
  },
};
